import { FC } from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../Icons/Icon';
export const MaintenanceWarningIcon: FC = () => {
  const handleClick = () => {
    // Clear the dismissed state from sessionStorage
    sessionStorage.removeItem('maintenance-mode');

    // Dispatch a custom event to notify the banner to re-render
    window.dispatchEvent(new CustomEvent('show-maintenance-banner'));
  };
  return <Tooltip label="View maintenance message" placement="bottom" backgroundColor="white" data-sentry-element="Tooltip" data-sentry-component="MaintenanceWarningIcon" data-sentry-source-file="MaintenanceWarningIcon.tsx">
      <IconButton aria-label="Maintenance mode active" icon={<ICON_BY_NAME.cautiontriangle width="20px" height="20px" />} variant="ghost" color="kirby.500" _hover={{
      backgroundColor: 'rgba(255, 89, 89, 0.1)'
    }} onClick={handleClick} size="sm" data-sentry-element="IconButton" data-sentry-source-file="MaintenanceWarningIcon.tsx" />
    </Tooltip>;
};